
import { defineComponent } from "vue";
import "@/assets/scss/doctors/patients-list.scss";
import axios from "axios";
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "versions",
  props: ["id"],
  data() {
    return {
      active: false,
      red: "red",
      success: "green",
      yellow: "yellow",
      activeModel: false,
      versions: [],
      title: "",
      body: "",
      status: "normal",
      normal: "normal",
      emergency: "emergency",
      isNullTitle: false,
      isNullBody: false,
    };
  },
  methods: {
    back() {
      this.$router.push("/doctor/patients");
    },
    fetchVersion() {
      axios
        .get(`doctor/patients/${this.id}/prescriptions`)
        .then((res) => {
          // console.log(res);
          this.versions = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveVersion() {
      let sccess = false;
      if (this.title === "") {
        this.isNullTitle = true;
      } else {
        this.isNullTitle = false;
        sccess = true;
      }
      if (this.body === "") {
        this.isNullBody = true;
      } else {
        this.isNullBody = false;
        sccess = true;
      }
      if (
        sccess == true &&
        this.isNullTitle == false &&
        this.isNullBody == false
      ) {
        axios
          .post(`doctor/patients/${this.id}/prescriptions`, {
            title: this.title,
            body: this.body,
            status: this.status,
          })
          .then(() => {
            // console.log(res);
            this.fetchVersion();
            window.alert("ثبت با موفقیت انجام شد");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.fetchVersion();
  },
});
